export const CLASS_NAME = 'cst-chart-bar'
